/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment/moment'
import Swal from 'sweetalert2'
const ahtTransactions = require('./lib/ahtTransactions.js')
const web3Factory = require('./lib/web3Helper');

Vue.use(Vuex)

function getOptions(data) {
  let web3 = web3Factory.getInstance()
  let options = []

  for(let i = 0; i < data.length; i++) {
    options.push({
      value: data[i],
      text: web3.utils.toUtf8(data[i])
    })
  }

  return options
}

function getHistory(data) {
  let users = data.result[0].length
  let history = []

  for(let i = 0; i < users; i++) {
    history.push({
      'address': data.result.sender[i],
      'amountStaked': data.result.amountStaked[i] / 1e18,
      'stakeDate': moment(new Date(data.result.stakeDate[i] * 1000)).fromNow(),
      'reward': data.result.reward[i] / 1e18,
      'payoutType': 'AHT'
    })
  }

  return history.reverse()
}

function getResults(data) {
  let results = []
  let options = data.result[0].length

  for (let i = 0; i < options; i++) {
    results.push({
      'option': data.result[0][i],
      'for': data.result[1][i] / 1e18,
      'against': data.result[2][i] / 1e18
    })
  }

  return results
}

export default new Vuex.Store({
  state: {
    surveyName: '',
    address: '',
    surveyOptions: [],
    amountStaked: null,
    realAmountStaked: null,
    surveyRewardPool: null,
    stakingHistory: [],
    balance: 0,
    endDate: 0,
    payoutType: 1,
    wallets: [
      'Metamask',
      'Trezor'
    ],
    wallet: 0, 
    isConnected: false,
    votes: 0,
    stakingActive: false,
    votedOptions: [],
    results: [],
    returnTokenDate: null,
    voted: false
  },
  mutations: {
    ADD_SURVEY_NAME (state, data) {
      state.surveyName = data.result
    },
    ADD_SURVEY_DATA(state, data) {
      state.surveyOptions = getOptions(data.result[0])
      state.endDate = data.result[3]
    },
    ADD_AMOUNT_STAKED(state, data) {
      state.amountStaked = data.result / 1e18
    },
    ADD_REAL_AMOUNT_STAKED (state, data) {
      state.realAmountStaked = data / 1e18
    },
    ADD_SURVEY_REWARD_POOL(state, data) {
      state.surveyRewardPool = data.result / 1e18
    },
    async ADD_SURVEY_STAKING_HISTORY(state, data) {
      state.stakingHistory = await getHistory(data)
    },
    ADD_USER_BALANCE(state, data) {
      state.balance = data.result / 1e18
    },
    ADD_PAYOUT_TYPE(state, data) {
      state.payoutType = data
    },
    ADD_IS_CONNECTED (state, status) {
      state.isConnected = status
    },
    UPDATE_WALLET (state, wallet) {
      state.wallet = wallet
    },
    ADD_ADDRESS (state, address) {
      state.address = address
    },
    ADD_VOTES_REMAINING (state, votes) {
      state.votes = votes.result / 1e18
    },
    ADD_STAKE_STATUS (state, status) {
      state.stakingActive = status
    },
    ADD_VOTED_OPTIONS (state, votedOptions) {
      state.votedOptions = votedOptions.result
    },
    async ADD_SURVEY_RESULT (state, data) {
      state.results = await getResults(data)
    },
    ADD_RETURN_TOKEN_DATE (state, date) {
      const stopStakeDate = new Date(date * 1000);
      stopStakeDate.setDate(stopStakeDate.getDate() + 3)
      state.returnTokenDate = stopStakeDate
    },
    ADD_VOTED_STATUS (state, data) {
      state.voted = data.result.voted
    }
  },
  actions: {
    async getSurveyActive ({commit}) {
      let surveyName = await ahtTransactions.getSurveyActive()

      commit('ADD_SURVEY_NAME', surveyName)
    },
    async getSurveyOptions ({ commit, getters }) {
      const surveyAddress = process.env.VUE_APP_SURVEY_ADDRESS

      let surveyData = await ahtTransactions.getSurveyOptions({
        contractAddress: surveyAddress,
        surveyName: getters.getSurveyName
      })

      commit('ADD_SURVEY_DATA', surveyData)
    },
    async getAmountStaked ({ commit }) {
      const surveyAddress = process.env.VUE_APP_SURVEY_ADDRESS

      let amountStaked = await ahtTransactions.getAmountStaked({
        contractAddress: surveyAddress
      })

      commit('ADD_AMOUNT_STAKED', amountStaked)
    },
    async getSurveyRewardPool ({ commit, getters }) {
      const surveyAddress = process.env.VUE_APP_SURVEY_ADDRESS

      let rewardPool = await ahtTransactions.getRewardPool({
        contractAddress: surveyAddress,
        surveyName: getters.getSurveyName
      })

      commit('ADD_SURVEY_REWARD_POOL', rewardPool)
    },
    async getStakingHistory ({commit, getters}) {
      const surveyAddress = process.env.VUE_APP_SURVEY_ADDRESS

      let stakingHistory = await ahtTransactions.getStakingHistory({
        contractAddress: surveyAddress,
        surveyName: getters.getSurveyName
      })

      commit('ADD_SURVEY_STAKING_HISTORY', stakingHistory)
    },
    async saveAnswer ({getters}, data) {
      const surveyAddress = process.env.VUE_APP_SURVEY_ADDRESS
      const wallet = getters.getWalletIndex

      let rawTx = {
        contractAddress: surveyAddress,
        address: data.address,
        surveyName: getters.getSurveyName,
        option: data.option,
        typeVote: data.typeVote,
        typeReward: getters.getPayoutType,
        wallet: wallet
      }
      
      await ahtTransactions.saveAnswer(rawTx)
    },
    async sendStake ({getters, dispatch, commit}, data) {
      const surveyAddress = process.env.VUE_APP_SURVEY_ADDRESS
      const tokenAddress = process.env.VUE_APP_AHTTOKEN_ADDRESS
      const wallet = getters.getWalletIndex

      try {
        let rawTx = {
          contractAddress: tokenAddress,
          address: data.address,
          surveyAddress: surveyAddress,
          amount: data.stakeAmount,
          wallet: wallet
        }

        Swal.fire({
          title: 'Please Wait',
          html: 'Waiting for approval',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        });
      
        await ahtTransactions.approve(rawTx);

        Swal.close();

        rawTx = {
          contractAddress: surveyAddress,
          address: data.address,
          surveyName: getters.getSurveyName,
          amountStake: data.stakeAmount,
          wallet: wallet
        }

        await ahtTransactions.sendStake(rawTx)

        await dispatch('getAmountStakedByUser', data.address)
        await dispatch('getStakingHistory')

        commit('ADD_STAKE_STATUS', true)

      } catch (error) {
        Swal.close();
        throw error
      }

      
    },
    async getBalance ({commit}, address) {
      const surveyAddress = process.env.VUE_APP_SURVEY_ADDRESS

      let balance = await ahtTransactions.getBalance({
        contractAddress: surveyAddress,
        address: address
      })

      commit('ADD_USER_BALANCE', balance)
    },
    async getAmountStakedByUser ({commit, getters}, address) {
      const surveyAddress = process.env.VUE_APP_SURVEY_ADDRESS

      let votes = await ahtTransactions.getAmountStakedByUser({
        contractAddress: surveyAddress,
        address: address,
        surveyName: getters.getSurveyName
      })

      commit('ADD_VOTES_REMAINING', votes)
    },
    setTypeReward ({commit}, typeReward) {
      commit('ADD_PAYOUT_TYPE', typeReward)
    },
    setIsConnected ({commit}, status) {
      commit('ADD_IS_CONNECTED', status)
    },
    setWallet ({commit}, wallet) {
      commit('UPDATE_WALLET', wallet)
    },
    setAddress ({commit}, address) {
      commit('ADD_ADDRESS', address)
    },
    async stopStake ({commit, getters, dispatch}, address) {
      const surveyAddress = process.env.VUE_APP_SURVEY_ADDRESS
      const wallet = getters.getWalletIndex

      let rawTx = {
        contractAddress: surveyAddress,
        address: address,
        wallet: wallet,
        surveyName: getters.getSurveyName
      }

      await ahtTransactions.stopStake(rawTx)

      dispatch('getAmountStakedByUser', address)

      commit('ADD_STAKE_STATUS', false)
    },
    async getVotedOptions ({commit, getters}, address) {
      const surveyAddress = process.env.VUE_APP_SURVEY_ADDRESS

      let votedOptions = await ahtTransactions.getVotedOptions({
        contractAddress: surveyAddress,
        address: address,
        surveyName: getters.getSurveyName
      })

      commit('ADD_VOTED_OPTIONS', votedOptions)
    },
    async getStakingInfo ({commit, getters}, address) {
      const surveyAddress = process.env.VUE_APP_SURVEY_ADDRESS

      let stakingInfo = await ahtTransactions.getStakingInfo({
        contractAddress: surveyAddress,
        address: address,
        surveyName: getters.getSurveyName
      })

      if(stakingInfo.result.stopStakeDate !== 0) {
        commit('ADD_RETURN_TOKEN_DATE', stakingInfo.result.stopStakeDate)
      }

      commit('ADD_REAL_AMOUNT_STAKED', stakingInfo.result.amountStaked)
      commit('ADD_STAKE_STATUS', stakingInfo.result.stakingActive)
    },
    async getVoteInfo ({commit, getters}, address) {
      const surveyAddress = process.env.VUE_APP_SURVEY_ADDRESS

      let voteInfo = await ahtTransactions.getVoteInfo({
        contractAddress: surveyAddress,
        address: address,
        surveyName: getters.getSurveyName
      })

      commit('ADD_VOTED_STATUS', voteInfo)
    },
    async getSurveyResult ({commit, getters}) {
      const surveyAddress = process.env.VUE_APP_SURVEY_ADDRESS

      let surveyData = await ahtTransactions.getSurveyResult({
        contractAddress: surveyAddress,
        surveyName: getters.getSurveyName
      })

      commit('ADD_SURVEY_RESULT', surveyData)
    }
  },
  getters: {
    getSurveyName (state) {
      return state.surveyName
    },
    getSurveyOptions (state) {
      return state.surveyOptions
    },
    getAmountStaked (state) {
      return state.amountStaked
    },
    getSurveyRewardPool (state) {
      return state.surveyRewardPool
    },
    getStakingHistory (state) {
      return state.stakingHistory
    },
    getBalance (state) {
      return state.balance
    },
    getAmountStakedByUser (state) {
      return state.votes
    },
    getEndDate (state) {
      return state.endDate
    },
    getPayoutType (state) {
      return state.payoutType
    },
    getIsConnected (state) {
      return state.isConnected
    },
    getWallet (state) {
      return state.wallets[state.wallet]
    },
    getWalletIndex (state) {
      return state.wallet
    },
    getAddress (state) {
      return state.address
    },
    getStakeStatus (state) {
      return state.stakingActive
    },
    getVotedOptions (state) {
      return state.votedOptions
    },
    getSurveyResults (state) {
      return state.results
    },
    getReturnTokensDate (state) {
      return state.returnTokenDate
    },
    getShowReturnTokens (state) {
      return state.realAmountStaked > 0 && !state.stakingActive
    }
  }
})
